import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";

@Component({
  selector: 'app-participation-help-modal',
  templateUrl: './participation-help-modal.component.pug',
  styleUrls: ['./participation-help-modal.component.scss'],
  standalone: false
})
export class ParticipationHelpModalComponent implements OnInit {
  @Input() request

  constructor(public _bsModalRef: BsModalRef) {
  }


  ngOnInit(): void {
  }

  close() {
    this._bsModalRef.hide();
  }

}
